import { Button } from '@material-tailwind/react';
import { ReactComponent as LeftIcon } from '@assets/images/left_icon.svg';
import { ReactComponent as SuccessIcon } from '@assets/icons/Success.svg';
import { ReactComponent as InfoErrorIcon } from '@assets/icons/info_error_icon.svg';
import { useEffect, useState } from 'react';
import clsx from 'clsx';
import { useOrgStore, useSellerStore } from '@stores';
import { getAssetSpecificContent } from '@utils';
import { AssetTypesEnum } from '@types';

export const MarinePhotos = ({
  setStep
}: {
  setStep: (step: string) => void;
}) => {
  const [primaryColor, setPrimaryColor] = useState('#002861');
  const { organisation } = useOrgStore();
  const {
    marineBack,
    marineFront,
    marineLeft,
    marineRight,
    assetType,
    documents
  } = useSellerStore();

  useEffect(() => {
    if (organisation.primaryColour !== '') {
      setPrimaryColor('#' + organisation.primaryColour);
    }
  }, []);

  return (
    <div className="py-4 mx-auto w-full overflow-hidden relative mb-4">
      <div className="flex flex-col gap-4">
        <p className="text-gray-700">
          <span className="font-semibold">
            Please ensure that all photos are real-time captures of the actual{' '}
            {getAssetSpecificContent(assetType as AssetTypesEnum).lowerTitle}.
          </span>
          <span>
            {' '}
            Images of printed photos or screenshots will be detected and
            rejected.
          </span>
        </p>
      </div>
      {/* Vehicle Front */}
      <Button
        onClick={() => setStep('marine-front')}
        className={clsx(
          'bg-grey-50 normal-case !rounded-none border-b border-grey-200 w-full p-5 text-dark-primary flex justify-between font-semibold text-lg mt-6',
          !marineFront.available && 'hidden'
        )}>
        <div className="flex gap-3">
          <p className="mr-2">
            {getAssetSpecificContent(AssetTypesEnum.MARINE).title} Front
          </p>
          {marineFront.isDone && <SuccessIcon className="mt-1 w-5 h-5" />}
          {!marineFront.isDone && documents?.MARINE_FRONT?.needsResubmit && (
            <InfoErrorIcon className="mt-1 w-5 h-5" />
          )}
        </div>
        <LeftIcon />
      </Button>

      {/* Passenger Side */}
      <Button
        onClick={() => setStep('marine-left')}
        className={clsx(
          'bg-grey-50 normal-case !rounded-none border-b border-grey-200 w-full p-5 text-dark-primary flex justify-between font-semibold text-lg',
          !marineLeft.available && 'hidden'
        )}>
        <div className="flex gap-3">
          <p className="mr-2">
            {getAssetSpecificContent(AssetTypesEnum.MARINE).sides.passenger}{' '}
            Side
          </p>
          {marineLeft.isDone && <SuccessIcon className="mt-1 w-5 h-5" />}
          {!marineLeft.isDone && documents?.MARINE_LEFT?.needsResubmit && (
            <InfoErrorIcon className="mt-1 w-5 h-5" />
          )}
        </div>
        <LeftIcon />
      </Button>

      {/* Vehicle Back */}
      <Button
        onClick={() => setStep('marine-back')}
        className={clsx(
          'bg-grey-50 normal-case !rounded-none border-b border-grey-200 w-full p-5 text-dark-primary flex justify-between font-semibold text-lg',
          !marineBack.available && 'hidden'
        )}>
        <div className="flex gap-3">
          <p className="mr-2">
            {getAssetSpecificContent(AssetTypesEnum.MARINE).title} Back
          </p>
          {marineBack.isDone && <SuccessIcon className="mt-1 w-5 h-5" />}
          {!marineBack.isDone && documents?.MARINE_BACK?.needsResubmit && (
            <InfoErrorIcon className="mt-1 w-5 h-5" />
          )}
        </div>
        <LeftIcon />
      </Button>

      {/* Driver's Side */}
      <Button
        onClick={() => setStep('marine-right')}
        className={clsx(
          'bg-grey-50 normal-case !rounded-none border-b border-grey-200 w-full p-5 text-dark-primary flex justify-between font-semibold text-lg',
          !marineRight.available && 'hidden'
        )}>
        <div className="flex gap-3">
          <p className="mr-2">
            {getAssetSpecificContent(AssetTypesEnum.MARINE).sides.driver} Side
          </p>
          {marineRight.isDone && <SuccessIcon className="mt-1 w-5 h-5" />}
          {!marineRight.isDone && documents?.MARINE_RIGHT?.needsResubmit && (
            <InfoErrorIcon className="mt-1 w-5 h-5" />
          )}
        </div>
        <LeftIcon />
      </Button>
    </div>
  );
};

